/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CustomWidgetTexture.vue?vue&type=template&id=835f0c98&scoped=true&"
import script from "./CustomWidgetTexture.vue?vue&type=script&lang=js&"
export * from "./CustomWidgetTexture.vue?vue&type=script&lang=js&"
import style0 from "./CustomWidgetTexture.vue?vue&type=style&index=0&id=835f0c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835f0c98",
  null
  
)

export default component.exports